import { ButtonColor } from '../Button/Button';
import { ButtonBorder } from '../Button/ButtonBorder';
import { Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import useScrollPosition from '@react-hook/window-scroll';
import { RoutePath } from 'RoutePath';
import { ReactComponent as SmallLogoIconWhite } from 'assets/logo-icon-white.svg';
import { ReactComponent as SmallLogoIcon } from 'assets/logo-icon.svg';
import { ReactComponent as MainLogoIconWhite } from 'assets/logo-white.svg';
import { ReactComponent as MainLogoIcon } from 'assets/logo.svg';
import { ButtonArrow } from 'components/Button/ButtonArrow';
import { makeUrl } from 'core/utils/utils';
import React, { useCallback } from 'react';
import i18n from '../../../i18n';
import { SelectLanguageControl } from '../SelectLanguageControl/SelectLanguageControl';

const useStyles = makeStyles(theme => ({
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 16px',
        marginTop: 20,
        marginBottom: 20,
        [theme.breakpoints.up(375)]: {
            padding: '0 16px',
        },
        [theme.breakpoints.up(479)]: {
            padding: '0 24px',
        },
        [theme.breakpoints.up(767)]: {
            padding: '0 40px',
        },
    },
    icon: {
        display: 'inline-flex',
        cursor: 'pointer',
    },
    logo: {
        maxHeight: 32,
        '&:hover': {
            '-webkit-transform': 'scale(1.2)',
            '-ms-transform': 'scale(1.2)',
            transform: 'scale(1.2)',
        },
    },
    buttonBlock: {
        display: 'flex',
    },
    buttonBack: {
        marginRight: theme.spacing(2),
    },
    addButtonPos: {
        width: '100%',
        bottom: 10,
        marginBottom: 10,
        marginLeft: -16,
        position: 'fixed',
    },
    button: {
        cursor: 'pointer',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));
export const Header = () => {
    const scrollY = useScrollPosition(60 /*fps*/);
    const classes = useStyles({ scrollY });
    const { t } = i18n.useTranslation();

    const onLogoClick = useCallback(() => {
        window.location.assign(RoutePath.FEED);
    }, []);

    const handleRegistrationClick = useCallback(() => {
        window.open(makeUrl(RoutePath.REGISTRATION), '_blank');
    }, []);

    const handleSetMapClick = useCallback(() => {
        window.location.assign(RoutePath.FEED);
    }, []);

    return (
        <div className={classes.header}>
            <div className={classes.logo} onClick={onLogoClick}>
                <Hidden xsDown>{scrollY > 640 ? <MainLogoIcon /> : <MainLogoIconWhite />}</Hidden>
                <Hidden smUp>{scrollY > 640 ? <SmallLogoIcon /> : <SmallLogoIconWhite />}</Hidden>
            </div>
            <Hidden smUp>
                <div className={classes.addButtonPos} onClick={onLogoClick}>
                    <ButtonBorder className={classes.button} color={ButtonColor.DARK}>
                        {t('common:about.back')}
                    </ButtonBorder>
                </div>
            </Hidden>
            <div className={classes.buttonBlock}>
                <div className={classes.buttonBack}>
                    <SelectLanguageControl />
                </div>
                <div onClick={handleSetMapClick} className={classes.buttonBack}>
                    <Hidden xsDown>
                        <ButtonBorder>{t('common:about.back')}</ButtonBorder>
                    </Hidden>
                </div>
                <div className={classes.icon} onClick={handleRegistrationClick}>
                    <ButtonArrow>{t('common:about.connectShop')}</ButtonArrow>
                </div>
            </div>
        </div>
    );
};
